import { enUSMessages } from "./en-US"

type MessageId = keyof typeof enUSMessages

export const zhHantMessages: Record<MessageId, string> = {
  ...enUSMessages,
  "settings.language.option.zh-Hant": "繁體中文",
}
